import React from 'react'
import EditorOutputCreator from '../utils/editor-output-creator'
import createReactClass from 'create-react-class'


var EditorOutput = createReactClass({

	getOutput: function() {
		var editorOutputCreator = new EditorOutputCreator();
		return JSON.stringify(editorOutputCreator.create(), null, 4);
	},


	render: function() {
		return (<div>
					<pre>{this.getOutput()}</pre>
				</div>);
	}
});

export default EditorOutput;
